import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { getApiModuleOptions } from './config.js';
import { ApiError } from './errors.js';
import { HttpHeader, ContentType, HttpStatus } from './constants.js';

var _excluded = ["headers", "body", "contentType", "auth", "abort"];

var apiRequest = function apiRequest(method, url) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options$headers = options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers,
      body = options.body,
      contentType = options.contentType,
      auth = options.auth,
      abort = options.abort,
      other = _objectWithoutProperties(options, _excluded);

  return new Promise(function (resolve, reject) {
    var object = _objectSpread2(_objectSpread2({}, other), {}, {
      method: method.toUpperCase(),
      headers: _objectSpread2({}, headers),
      body: undefined,
      signal: abort === null || abort === void 0 ? void 0 : abort.signal
    });

    if (contentType !== null && contentType !== undefined) {
      object.headers[HttpHeader.ContentType] = contentType;
    }

    if (auth !== null && auth !== undefined) {
      object.headers[HttpHeader.Authorization] = auth;
    }

    if (body !== null && body !== undefined) {
      if (contentType && contentType.includes(ContentType.Json)) {
        object.body = JSON.stringify(body);
      } else {
        object.body = body;
      }
    }

    var rejected = false;

    if (abort !== undefined) {
      if (abort.aborted) {
        // aborted before request started
        reject(abort.reason);
        return;
      }

      if (!abort.signal) {
        // manually handle aborts where AbortSignal not supported
        var onAbort = function onAbort(reason) {
          rejected = true;
          abort.removeListener(onAbort);
          reject(reason);
        };

        abort.addListener(onAbort);
      }
    }

    fetch(url, object).then(function (response) {
      if (rejected) return;

      if (!response.ok) {
        var onErrorResponse = getApiModuleOptions().onErrorResponse;
        onErrorResponse(response).then(function (error) {
          return reject(error);
        });
        return;
      }

      var handleResponse = function handleResponse(r) {
        resolve(r);
      };

      var responseType = response.headers.get(HttpHeader.ContentType);

      if (!responseType || options.preventResponseHandling) {
        handleResponse(response);
      } else if (responseType.includes(ContentType.Json)) {
        // json response (silently catch errors caused by no data being returned by server)
        response.json().then(function (data) {
          return handleResponse(data);
        }).catch(function (error) {
          return handleResponse(null);
        });
      } else if (responseType.includes(ContentType.Zip) || responseType.includes(ContentType.Pdf) || responseType.includes(ContentType.OctetStream) || responseType.includes(ContentType.Image)) {
        // blob file types
        response.blob().then(function (data) {
          return handleResponse(data);
        });
      } else if (responseType.includes(ContentType.Text)) {
        // text file types
        response.text().then(function (data) {
          return handleResponse(data);
        });
      } else {
        // unsupported type
        handleResponse(response);
      }
    }).catch(function (e) {
      if (rejected) return;
      var error = e;

      if (error.name === "AbortError" || abort !== null && abort !== void 0 && abort.aborted) {
        reject(abort === null || abort === void 0 ? void 0 : abort.reason);
      } else {
        var failureError = getApiModuleOptions().fetchFailureError;
        reject(new ApiError(failureError || error.message, HttpStatus.ServiceUnavailable));
      }
    });
  });
};

export { apiRequest };
